module.exports = __webpack_public_path__ + "static/media/heartbeat-2.380acd23.png";